import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.string.starts-with.js";
import axios from 'axios';
import Vue from 'vue';
import Qs from 'qs';
import * as Config from '@/config';
import Drip from 'drip';
import User from 'drip/user';
import Cookie from 'drip/utils/cookie';
import EvokeYoda from '@/utils/yoda';
import { ajaxErrorProcess, isCrawlEnabled, ajaxSuccessLog } from './index';
import mockApis from './mockApis';
import parseUrl from 'url-parse';
var isProd = Config.isProd;
var xorKey = 193056183;
axios.defaults.baseURL = Config.ajaxPreUrl;
axios.defaults.timeout = 15000;
// axios.defaults.headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
axios.defaults.withCredentials = true;

// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN
// 添加请求拦截器

var delParam = function delParam(obj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // if (typeof obj !== 'object') throw new Error('[method "delParam" ]: Must need to add an object')
  obj = obj || {};
  !Array.isArray(params) && (params = [params]);
  for (var param in params) delete obj[params];
};

// let $Loading, errorTips
function arrIncludesUrl(arr, myurl) {
  for (var i = 0; i < arr.length; i++) {
    if (myurl.includes(arr[i])) {
      return true;
    }
  }
  return false;
}
var errorTips;
axios.interceptors.request.use(function (config) {
  var params = config.params,
    headers = config.headers,
    url = config.url,
    data = config.data,
    method = config.method;
  // // !$Loading && ($Loading = document.getElementById('__myshow_loading__'))
  errorTips = true;
  params = params || {};
  data = data || {};

  // url 添加常规环境信息
  try {
    params = typeof params === 'string' ? Qs.parse(params) : params;
    var _ref = Drip.constant || {},
      appType = _ref.appType,
      lng = _ref.lng,
      lat = _ref.lat,
      _ref$cityId = _ref.cityId,
      cityId = _ref$cityId === void 0 ? 1 : _ref$cityId;
    var token = User.token;
    // 添加公共参数 ， 这里需要每次请求重新赋值， 防止数据变化 更新不及时

    /** 压力测试专用 */
    var isTest = Cookie.get('_istest');
    Boolean(isTest) && (params.istest = true);
    /** 压力测试专用 */

    /** 灰度测试专用 */
    var isGray = location.search.includes('isshowgray=true');
    if (isGray) params.isshowgray = true;
    var isGray2 = location.search.includes('isshow2gray=true');
    if (isGray2) params.isshow2gray = true;
    /** 灰度测试专用 */

    /** mock */
    var reg = /.*mock\//;
    if (Cookie.get('mock') && arrIncludesUrl(mockApis, url)) {
      var _url = url.replace(/.*mock/, '');
      config.url = "".concat(location.origin, "/app/mock/879").concat(_url);
    } else {
      config.url = url.replace('/mock', '');
    }
    // mtsi增加的参数: optimus_risk_level=71&optimus_code=10 https://km.sankuai.com/page/108012732
    params.optimus_risk_level = 71;
    params.optimus_code = 10;
    params.uuid = Drip.User.uuid || '';
    params.clientPlatform = Drip.UA.osName === 'ios' ? 2 : Drip.UA.osName === 'android' ? 1 : 3;
    if (!params.sellChannel && !params.token) {
      var obj;
      if (url.indexOf('cityId') > -1) {
        obj = {
          sellChannel: appType,
          lng: lng,
          lat: lat,
          token: token
        };
      } else {
        obj = {
          sellChannel: appType,
          cityId: cityId,
          lng: lng,
          lat: lat,
          token: token
        };
      }
      var _lng = params.lng;
      var _lat = params.lat;
      Object.assign(params, obj);
      if (!lng && !lat) {
        params.lng = _lng;
        params.lat = _lat;
      }
    }

    // 猫眼app隐私信息合规：https://wiki.maoyan.com/pages/viewpage.action?pageId=235227528
    if (Drip.UA.IS_MAOYAN) {
      // 经度 保留5位小数
      params.ax = Math.trunc((params.lng || 0) * 100000) ^ xorKey;
      // 纬度 保留5位小数
      params.bx = Math.trunc((params.lat || 0) * 100000) ^ xorKey;
      delete params.lng;
      delete params.lat;
    }
    if (params.loading) {
      delete params.loading;
    }
    if (params.noErrTip) {
      errorTips = false;
      delete params.noErrTip;
    }
    if (method === 'get' && !headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    if (!isProd) {
      // test 环境使用请勿上线
      // headers['ufe-force'] = 'on'
      // config.headers[ 'swimlane' ] = '3803-xoocn'
    }
  } catch (error) {
    console.log(error);
  }
  var resolveParams = function resolveParams(obj) {
    Object.keys(obj).forEach(function (key) {
      if (typeof obj[key] === 'undefined' || obj[key] === '') {
        delete obj[key];
      }
    });
  };
  resolveParams(params);
  resolveParams(data);
  config.params = params;
  config.data = data;
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  return Promise.reject(error);
});
// 需要过滤 不处理结果集的 url
var FILTER_ORIGINS_URLS = ['api.maoyan.com/inf/cos', 'mycos.movie.test.sankuai.com/cos', '/tx/smsOrder/detailV2', '/tour/addWish',
//许愿为登录部分场景定制，不处理结果集
'/tour/cancelWish'];
// 添加响应拦截器
axios.interceptors.response.use(function (res) {
  var data = res.data,
    status = res.status,
    _res$headers = res.headers,
    headers = _res$headers === void 0 ? {} : _res$headers,
    request = res.request;

  // 接口报业务错误
  if (data && data.code !== 200 && !data.success) {
    setTimeout(function () {
      var _res$config, _window, _data$error;
      var requestUrl = (res === null || res === void 0 ? void 0 : (_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) || '';
      try {
        var urlObj = parseUrl(requestUrl);
        requestUrl = "".concat(urlObj.origin).concat(urlObj.pathname);
        requestUrl = requestUrl.replace(/(?:\/\d{2,})/g, '/*');
      } catch (e) {}
      (_window = window) === null || _window === void 0 ? void 0 : _window.owl('addError', {
        name: "\u63A5\u53E3\u4E1A\u52A1\u62A5\u9519 ".concat(data.code || (data === null || data === void 0 ? void 0 : (_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.code), " ").concat(requestUrl),
        msg: res
      }, {
        category: 'ajaxError',
        level: 'warn',
        combo: true
      });
    }, 0);
  } else {
    ajaxSuccessLog(res);
  }
  var responseURL = (request || {}).responseURL;
  // 部分 URL 不走处理逻辑
  if (FILTER_ORIGINS_URLS.some(function (x) {
    return responseURL.includes(x);
  })) return res;
  var code = data.code,
    error = data.error;
  if (code === 403 || error && error.code === 403) {
    Drip.login({
      force: true
    }).then(function (res) {
      if (Drip.UA.isNative) {
        window.location.reload();
      }
    }).catch(function (err) {
      console.warn(err);
    });
    return;
  }
  if (errorTips && code !== 200 && code !== 403) {}
  // cookie httpOnly 下处理登录态下特殊逻辑
  var headerToken = headers['token'] || headers['TOKEN'];
  if (!User.isLogin && headerToken) User.setToken(headerToken);
  if (Drip.constant.sellChannel === 13 && Drip.User.token && Drip.User.token.startsWith('MY_')) {
    // m 站token 应该以非MY_开头
    window.Owl && window.Owl.addError({
      name: 'm站token以MY_开头',
      msg: {
        dripConstant: Drip.constant,
        res: res
      }
    }, {
      category: 'jsError',
      level: 'error'
    });
    Drip.User.setToken('');
    Drip.User.logout(location.href);
    return;
  }
  if (data && data.code === 406 && data.customData && data.customData.requestCode) {
    // mtsi 拦截
    EvokeYoda({
      requestCode: data.customData.requestCode
    }).then(function (isPass) {
      if (isPass) {
        // window.location.reload() 在安卓机中的app不生效 在路径中添加时间戳
        Drip.reload();
      }
    }).catch(function (err) {
      console.warn(err);
    });
  }
  return data;
}, function (error) {
  ajaxErrorProcess(error);
  if (error.response && error.response.status === 401) {
    // 未登录
  } else if (errorTips) {}
  // 对响应错误做点什么
  return Promise.reject(error);
});
Vue.prototype.$http = axios;
export default axios;